<ng-container *ngTemplateOutlet="skeletonDetails"></ng-container>

<ng-template #skeletonDetails>
  <div class="rounded-4 min-h-500px w-100 px-0">
    <div class="card-header py-8">
      <div class="d-flex flex-column">
        <div class="d-flex flex-row align-items-center gap-5 mb-6">
          <div class="skeleton h-25px w-25"></div>
          <div class="skeleton h-20px w-80px"></div>
        </div>
        <div class="d-flex flex-row gap-2">
          <div class="skeleton w-100px h-20px"></div>
          <div class="skeleton w-100px h-20px"></div>
        </div>
      </div>
    </div>
    <!-- The real body is one flowing article block
         ([innerHTML]="blog_info.article") — a single column, not the
         two-column text-beside-a-box layout this used to sketch, which had
         nothing in the real content to correspond to. Paragraph lines with an
         occasional full-width media block in between, since an article can
         embed an image, but never a side column. -->
    <div class="card-body d-flex flex-column justify-content-between p-8">
      <div class="d-flex flex-column">
        <div class="skeleton h-25px w-100 mb-4"></div>
        <div class="skeleton h-25px w-100 mb-4"></div>
        <div class="skeleton h-25px w-75 mb-12"></div>

        <div class="skeleton h-250px w-100 mb-12"></div>

        <div class="skeleton h-25px w-100 mb-4"></div>
        <div class="skeleton h-25px w-100 mb-4"></div>
        <div class="skeleton h-25px w-50"></div>
      </div>
    </div>
  </div>
</ng-template>
